import { useCallback, useEffect, useState } from "react";

import { canAccess } from "hooks/useEnforcer";
import storage from "utils/storage";

import { NotAuthorized } from "./NotAuthorized";

interface AuthorizationProps {
  permission: string[] | undefined;
  forbiddenFallback?: React.ReactNode;
  children: any;
  showDefaultForbidden?: boolean;
  isSuperAdmin?: boolean;
  isEmpty?: boolean;
}

const Authorization = ({
  permission,
  forbiddenFallback,
  children,
  showDefaultForbidden = false,
  isSuperAdmin,
  isEmpty,
}: AuthorizationProps) => {
  const [firstLoading, setFirstLoading] = useState(true);
  const [result, setResult] = useState(false);
  const userPermissions = storage.getPermissionsMenu();

  const getCanAccess = useCallback(async () => {
    const resultAccess = await canAccess(permission, userPermissions);

    if (resultAccess !== undefined && resultAccess !== null) {
      setFirstLoading(false);
      setResult(resultAccess);
    }
  }, [permission, userPermissions]);

  useEffect(() => {
    getCanAccess();
  }, [permission, getCanAccess]);

  if (firstLoading) {
    return null;
  }
  // eslint-disable-next-line
  return result === true
    ? children
    : isEmpty
    ? null
    : <NotAuthorized /> ?? null;
};

export default Authorization;
